// @flow
import * as React from 'react';
import { IntlShape, injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import type { SwitchDataPort } from 'esm-web-pro/types/networks';
import { Box } from 'grommet';
import SFPRow from 'esm-web-pro/containers/pages/network/objects/point12/poplayer12/SFPRow';
import sfpMessages from 'esm-web-pro/containers/pages/network/objects/sfp/sfpMessages';
import AddSFP, { ADD_SFP_KEY } from 'esm-web-pro/containers/pages/network/objects/point12/poplayer12/AddSFP';
import { bindActionCreators } from 'redux';
import { openPanel as openPanelAction } from 'esm-web-pro/redux/side-panel';
import { connect } from 'react-redux';
import { ObjectContext } from 'esm-web-pro/containers/map/MapObject';
import Spinner from 'esm-web-pro/components/forms/Spinner';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';


type Props = {
    dataPort: SwitchDataPort,
    intl: IntlShape,
    pointCoords: [number, number],

    openPanel: (key: string, url: ?string) => { key: string, url: string },
};

const DataPortContent = (props: Props) => {
    const {
        dataPort, intl: { formatMessage }, openPanel, pointCoords,
    } = props;

    const { reload, loading } = React.useContext(ObjectContext);

    const panelTitle = (
        <FormattedMessage
            id="add-sfp-title"
            defaultMessage="Add SFP to Data port {dataPort}"
            values={{
                dataPort: dataPort.data_port_number,
            }}
        />
    );

    const handleAddSFP = () => {
        openPanel(ADD_SFP_KEY + dataPort.data_port_number, panelTitle);
    };

    const sfpRowId = dataPort.sfp ? `PORT-${dataPort.sfp.uuid}` : null;

    return loading ? (
        <Box pad={{ top: 'medium' }}>
            <Spinner
                type="clipLoader"
                loading
                blocking={false}
                color="black"
                coverStyle={{
                    position: 'relative',
                    width: 'auto',
                    height: '100%',
                }}
            />
        </Box>
    ) : (
        <>
            <AddSFP port={dataPort} onSave={reload} panelTitle={panelTitle} />
            <Box
                key={dataPort.uuid}
                pad={{ vertical: '20px', horizontal: 'small' }}
                height={{ min: '100%' }}
            >
                <Box pad={{ horizontal: 'small' }} key={`sfp-list-box-${dataPort.id}`}>
                    <LabelText>{formatMessage(sfpMessages.sfps)}</LabelText>
                </Box>
                <SFPRow
                    SFP={dataPort.sfp}
                    pointCoords={pointCoords}
                    rowId={sfpRowId}
                    onAddSFP={handleAddSFP}
                    onRemoveSFP={reload}
                    portPadLevel={2}
                />
            </Box>
        </>
    );
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(
    { openPanel: openPanelAction },
    dispatch,
));

export default connect(null, mapDispatchToProps)(withRouter(injectIntl(DataPortContent)));
